var PhxCheckout = (function (PhxCheckout) {

    PhxCheckout.labelFloatHelper = function () {

        var _setLabelFloater= function(styleFlag)
        {
            window.floatLabel= Boolean(styleFlag);
            var floatClasses = document.getElementsByClassName('floatStyle');
            var defaultClasses = document.getElementsByClassName('defaultStyle');
            toggleDisplay(floatClasses,defaultClasses,styleFlag);
            checkDisplay(styleFlag);
        }
        var _getPlaceholder = function (labelId,inputId) 
        {
           
            if(document.getElementById(labelId).classList[0]=='floatLabel' || document.getElementById(inputId).value==='')
            {
                makeFloat(labelId);
                document.getElementById(inputId).style.paddingTop='18px';
            }
            else 
            {
                if(document.getElementById(inputId).value==='' )
                {
                    makeUnfloat(labelId);
                }
            }
            //adding Enter text after focus in
            if(inputId=="id_number" && document.getElementById("creditcardlabel").innerHTML.includes("Enter") == false) {
                document.getElementById("creditcardlabel").innerHTML = window.ENTER_CREDIT_DEBIT_CARD;
            }
            colorchangeForLabels();
           
        }
        var colorchangeForLabels = function() {
            //credit card error color condition
            if(document.getElementById("cc_number_error").style.display=="none")
            {
                document.getElementById("creditcardlabel").classList.remove("errorLabel");
            }
            else{
                document.getElementById("creditcardlabel").classList.add("errorLabel");
            }
             //month and year error color condition
             if(document.getElementById("expiration_error").style.display=="none")
            {
                document.getElementById("monthLabel").classList.remove("errorLabel");
                document.getElementById("yearLabel").classList.remove("errorLabel");
            }
            else{
                document.getElementById("monthLabel").classList.add("errorLabel");
                 document.getElementById("yearLabel").classList.add("errorLabel");
            }
            //cvv error color condition
             if(document.getElementById("cvc_error").style.display=="none")
            {
                document.getElementById("cvvlabel").classList.remove("errorLabel");
            }
            else{
                document.getElementById("cvvlabel").classList.add("errorLabel");
            }
        }
        var _onFocusOut= function(labelId,inputId) {
            
            //removing Enter text after focus out 
            var labelText = document.getElementById("creditcardlabel").innerHTML
            var inputValue = document.getElementById("id_number").value
            if(inputValue!==""){
                    labelText = window.CREDIT_DEBIT_CARD;
                    document.getElementById("creditcardlabel").innerHTML = labelText;
            }
             if(document.getElementById(labelId).classList[0]!='floatLabel'  && document.getElementById(inputId).value==='')
            {
                makeUnfloat(labelId);
            }
            colorchangeForLabels();
        }
        var _onInputClick = function(labelId){
            makeFloat(labelId);
        }
        var makeFloat = function(labelId)
        {
            document.getElementById(labelId).classList.remove('floatLabel');
            document.getElementById(labelId).classList.add('smallLabel');
        }

        var makeUnfloat = function(labelId)
        {
            document.getElementById(labelId).classList.remove('smallLabel');
            document.getElementById(labelId).classList.add('floatLabel');
            document.getElementById(labelId).style.color='#949494 !important;'
        }
          var toggleDisplay = function(floatClass,defaultClass,styleFlag) {
            // the length of floatClass and defaultClass will always be same for the A/B testing purpose
            for(var i=0, len=floatClass.length; i<len; i++)
            {
                if (i == len - 1) {
                floatClass[i].style["display"] = styleFlag == true ? 'inline-block' : 'none';
                defaultClass[i].style["display"] = styleFlag == false ? 'inline-block' : 'none';
                } else {
                floatClass[i].style["display"] = styleFlag == true ? 'block' : 'none';
                defaultClass[i].style["display"] = styleFlag == false ? 'block' : 'none';
                }
            }
        }
        // since there are two input fields for the different style(float and unfloat) , data is 
        // alway fetched from floating input fields , so altering the floating input field ids when flag is false.
        // the below method is not needed when it rolls out permanently.
        var checkDisplay = function(floatLabel){
               var outerDiv = document.getElementsByClassName('defaultStyle')[1];
               var innerDiv = outerDiv.querySelector('#id_expirationMonth');
              if(floatLabel==true && document.getElementById('hide_id1'))
                {
                    document.getElementById('hide_id1').id="id_number";
                    document.getElementById('hide_id2').id="id_expirationMonth";
                    document.getElementById('hide_id3').id="id_expirationYear";
                    document.getElementById('hide_id4').id="id_securityCode";
                }
                else if(floatLabel==false)
                {
                    document.getElementById('id_number').id="hide_id1";
                    document.getElementById('id_expirationMonth').id="hide_id2";
                    document.getElementById('id_expirationYear').id="hide_id3";
                    document.getElementById('id_securityCode').id="hide_id4";
                    innerDiv.setAttribute('autocomplete','cc-exp-month');
                    innerDiv.setAttribute('name','ExpirationMonth');
                }
                if(floatLabel==true)
                {
                    innerDiv.removeAttribute('autocomplete');
                    innerDiv.removeAttribute('name');
                }
        }

        return {

            getPlaceholder:_getPlaceholder,
            setLabelFloater:_setLabelFloater,
            onFocusOut:_onFocusOut,
            onInputClick:_onInputClick
        }



    }();
    
      return PhxCheckout;

}(PhxCheckout || {}));
      
if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    module.exports = PhxCheckout //export it as module only for jest.
}

